import { useRef, useState } from 'react';
import { Heart } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { buildGreetingCards, type GreetingCard } from '@/lib/saleGreetings';
import SalesGreetingCards from './SalesGreetingCards';
type Sale = { id: string; number: string; customerName: string | null };
function GreetingAction({ sale }: { sale: Sale }) {
  const [cards, setCards] = useState<GreetingCard[] | null>(null);
  const trigger = useRef<HTMLButtonElement>(null);
  return (
    <>
      <button
        ref={trigger}
        type="button"
        onClick={() => setCards(buildGreetingCards([sale]))}
        className="inline-flex min-h-11 items-center gap-2 rounded-lg border border-border px-3 text-sm"
      >
        <Heart className="h-4 w-4" />
        Print greeting
      </button>
      {cards && (
        <SalesGreetingCards
          cards={cards}
          onClose={() => {
            setCards(null);
            requestAnimationFrame(() => trigger.current?.focus());
          }}
        />
      )}
    </>
  );
}
export default function SaleGreetingAction({ sale }: { sale: Sale }) {
  const { profile, organization, access, can } = useAuth();
  if (!can('sales.view')) return null;
  return (
    <GreetingAction
      key={[sale.id, profile?.id, organization?.id, access?.access_version].join(':')}
      sale={sale}
    />
  );
}
